import { Pipe, PipeTransform } from '@angular/core';
import { BaseObject } from '@adgate/common/types/base-object.type';

@Pipe({
  name: 'objectList',
  standalone: true
})
export class ObjectListPipe implements PipeTransform 
{
  transform(value: BaseObject[], ..._args: unknown[]): string {
    let list: string = "";

    if ( value != null ) {
      return value.map( obj => obj.description ).join(", ");
    }

    return list;
  }
}
